export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    
    headline: 'Experience The Gamified Learning',
    description:
      'Learning Experience like Never Before!!..Join Us Now..',
    buttonLabel: 'GET STARTED',
    imgStart: '',
    img: 'KidsImage.png',
    alt: 'Kids'
  };
  
  